module.exports = __webpack_public_path__ + "static/cover-large-7351f782709cd0c88492a1de5819bd65.jpg";